import { useEffect, useState } from 'react';
import Immutable from "immutable";

export const useFetchGenericOffers = ({ adapter, requestOffers, immOffers = Immutable.fromJS({}), originCountry, featureFlags = undefined }) => {
    const [parsedOffers, setParsedOffers] = useState([]);
    const [error, setError] = useState(false);

    const handleOffers = () => {
        requestOffers();
    }

    useEffect(() => {
        handleOffers();
    }, []);

    useEffect(() => {
        if (immOffers.get('data').size && !immOffers.get('loading')) {
            try {
                const processedOffersData = adapter({ offers: immOffers, originCountry, featureFlags })
                setParsedOffers(processedOffersData.offers);
                setError(false);
            } catch (error) {
                setError(true);
                setParsedOffers([]);
            }
        } else {
            setParsedOffers([]);
        }
    }, [immOffers]);
    return {
        refetchOffers: handleOffers,
        parsedOffers,
        error: !!immOffers.get('error') || error,
        loading: !!immOffers.get('loading')
    }
}